import React from 'react';
import expert0 from 'images/experts/vinnatillsammans.png';
import expert1 from 'images/experts/f_mammen.jpg';
import expert2 from 'images/experts/n_mammen.jpg';
import expert3 from 'images/experts/olsen.jpg';
import expert4 from 'images/experts/dalgaard.jpg';
import expert5 from 'images/experts/friis.jpg';
import ExpertItem from './ExpertItem';
import Hr from 'ui/Hr';
import { Expert } from './server';

interface ExpertsProps {
    expertsList: Expert[];
}

const Experts = ({ expertsList }: ExpertsProps) => {
    // const data = [
    //     {
    //         title: 'VinnaTillsammans (ansat hos Derby25)',
    //         text:
    //             'Svensk succesduo bestående af Mathias Blomquist og Pontus Chorell. Har vundet flere milliongevinster gennem andelsspil hos SpilKlub25’s svenske pendant Tillsammans. Er kendt for at gå deres egne veje og spille aggressivt i jagten på de store gevinster.',
    //         photoSrc: expert0,
    //         groupIds: [30181],
    //     },
    //     {
    //         title: 'Frederik Mammen (ansat hos Derby25)',
    //         text:
    //             'Vandt VM-sølv i V75-konkurrencen i 2019 afviklet af ATG. Er kommet på travbanen, siden han kunne gå, og den 35-årige traventusiast er klar med knivskarpe analyser og andelsspil til gavn for dig.',
    //         photoSrc: expert1,
    //         groupIds: [899],
    //     },
    //     {
    //         title: 'Nicolai Mammen (ansat hos Derby25)',
    //         text:
    //             'Nicolai er vokset op på travbanen og har fulgt trav hele sit liv. Han har de seneste år opnået stor erfaring med anpartsspil, hvilket har resulteret i, at han har kunnet indløse nogle store gevinster. Derudover har han vundet Dansk Hoppe Derby som ejer af hesten Commit Boom Bay.',
    //         photoSrc: expert2,
    //         groupIds: [899, 7657],
    //     },
    //     {
    //         title: 'Morten Olsen (ansat hos Derby25)',
    //         text:
    //             'Er til daglig Head of Horses og oddschef hos Derby25. Som hesteejer vandt han Jydsk 4. Års Grand Prix tilbage i 1999 med hesten Come On Flamingo. Morten Olsen har i 20 år analyseret og spillet på trav.',
    //         photoSrc: expert3,
    //         groupIds: [109],
    //     },
    //     {
    //         title: 'Thomas Dalgaard (ansat hos Derby25)',
    //         text:
    //             'I kender ham måske fra fodboldens verden, hvor Thomas Dalgaard er tidligere Superliga-bomber. I dag fungerer han til dagligt som produktekspert for Derby25-forhandlerne og har i mange år haft en passion for hestesporten. Han er desuden medejer af hesten Google.',
    //         photoSrc: expert4,
    //         groupIds: [731],
    //     },
    //     {
    //         title: 'Henrik Friis (ansat hos Derby25)',
    //         text:
    //             'Opvokset i hestesporten og har fulgt den hele livet på tætteste hold. Er hesteejer med stor indsigt i sporten og er samtidig bror til en af Danmarks absolut bedste kuske, Morten Friis.',
    //         photoSrc: expert5,
    //         groupIds: [671],
    //     },
    // ];

    return (
        <>
            {expertsList.map((expertData) => (
                <>
                    <ExpertItem
                        title={expertData.name}
                        text={expertData.description}
                        photoSrc={expertData.photo}
                        groups={expertData.groups}
                    />
                    <Hr />
                </>
            ))}
        </>
    );
};

export default Experts;
